import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.125 9.39a.698.698 0 0 1-.208-.157h1.037a.7.7 0 0 1-.829.157ZM9.39 5.125a.7.7 0 0 1-.157.829V4.917a.698.698 0 0 1 .157.208ZM11.476 4a8.132 8.132 0 0 1 1.048 0 .7.7 0 0 1-.09 1.397 6.721 6.721 0 0 0-.868 0A.7.7 0 1 1 11.476 4Zm3.134 1.126a.7.7 0 0 1 .937-.317c.315.156.619.331.908.525a.7.7 0 0 1-.779 1.164 6.61 6.61 0 0 0-.749-.434.7.7 0 0 1-.317-.938Zm3.086 2.228a.7.7 0 0 1 .97.192c.195.29.37.593.526.908a.7.7 0 1 1-1.255.62 6.614 6.614 0 0 0-.434-.75.7.7 0 0 1 .193-.97Zm-12.953 3.47a.7.7 0 0 1 .653.743 6.726 6.726 0 0 0 0 .868.7.7 0 1 1-1.397.09 8.127 8.127 0 0 1 0-1.048.7.7 0 0 1 .744-.654Zm14.514 0a.7.7 0 0 1 .744.653 8.06 8.06 0 0 1 0 1.048.7.7 0 1 1-1.397-.09 6.778 6.778 0 0 0 0-.868.7.7 0 0 1 .653-.744ZM5.125 14.61a.7.7 0 0 1 .938.317c.128.26.273.51.433.75a.7.7 0 1 1-1.163.778 8.002 8.002 0 0 1-.525-.908.7.7 0 0 1 .317-.937Zm9.642 3.436a.7.7 0 0 0 0 1.037v-1.037Zm4.316-3.28a.701.701 0 0 0-1.037 0h1.037Zm-11.73 2.93a.7.7 0 0 1 .97-.192c.24.16.49.305.75.433a.7.7 0 0 1-.62 1.255 8.007 8.007 0 0 1-.908-.525.7.7 0 0 1-.193-.971Zm3.47 1.561a.7.7 0 0 1 .743-.653 6.7 6.7 0 0 0 .868 0 .7.7 0 0 1 .09 1.397 8.132 8.132 0 0 1-1.048 0 .7.7 0 0 1-.654-.744Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h5.533a.7.7 0 0 1 .7.7v5.533a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v4.133h4.133V4.4H4.4ZM14.067 14.767a.7.7 0 0 1 .7-.7H20.3a.7.7 0 0 1 .7.7V20.3a.7.7 0 0 1-.7.7h-5.533a.7.7 0 0 1-.7-.7v-5.533Zm1.4.7V19.6H19.6v-4.133h-4.133Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
